import React from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import Grid, { GridProps } from '@material-ui/core/Grid';
import StarIcon from './StarIcon';
import T from 'i18n-react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import type { StarIconProps } from './StarIcon';

type SquareButtonProps = ButtonProps & {
  favorite: boolean,
  totalCount: number,
  isMouseEntered: boolean,
  mouseEnter: boolean,
};

const StyledIcon: React.FC<StarIconProps> = withStyles({
  root: {
    fontSize: 36,
  },
})(StarIcon);

const ButtonGrid: React.FC<GridProps> = withStyles((theme) => ({
  root: {
    marginLeft: 'auto',
    textAlign: 'right',
    paddingLeft: `${theme.spacing(2)}px !important`,
  },
}))(Grid);

const StyledButton: React.FC<ButtonProps> = withStyles((theme) => ({
  root: {
    maxWidth: 400,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
    },
  },
  label: {
    fontWeight: 'bold',
  },
}))(Button);

const Count: React.FC<TypographyProps> = withStyles((theme) => ({
  root: {
    fontSize: theme.typography.pxToRem(20),
  },
}))(Typography);

const SquareButton = ({
  favorite,
  totalCount,
  isMouseEntered,
  mouseEnter,
  ...props
}: SquareButtonProps) => {
  return (
    <Grid container spacing={1} alignItems="center" wrap="nowrap">
      <Grid item>
        <StyledIcon checked={favorite} />
      </Grid>
      {totalCount > 0 && (
        <Grid item>
          <Count>{totalCount > 999 ? '999+' : totalCount}</Count>
        </Grid>
      )}
      <ButtonGrid item xs>
        <StyledButton
          variant={favorite ? 'contained' : 'outlined'}
          color={isMouseEntered ? 'secondary' : 'primary'}
          fullWidth
          disableElevation
          {...props}
        >
          {favorite
            ? T.translate(mouseEnter ? 'plan.disfavor' : 'plan.isFavorite')
            : T.translate('plan.favor')}
        </StyledButton>
      </ButtonGrid>
    </Grid>
  );
};

export default SquareButton;
